import React from 'react';
import { Building2, Home, Building } from 'lucide-react';
import { PropertyType } from '../../../types/estimation';

interface PropertyTypeSelectProps {
  value: PropertyType;
  onChange: (type: PropertyType) => void;
}

const OPTIONS: { type: PropertyType; icon: React.ElementType; label: string }[] = [
  { type: 'apartment', icon: Building2, label: 'Appartement' },
  { type: 'house', icon: Home, label: 'Maison' },
  { type: 'building', icon: Building, label: 'Immeuble' },
];

export const PropertyTypeSelect: React.FC<PropertyTypeSelectProps> = ({ value, onChange }) => {
  return (
    <div style={{ marginTop: 16 }}>
      <label style={{
        fontSize: 11, fontWeight: 500, color: '#7C6FA0',
        textTransform: 'uppercase', letterSpacing: '0.06em',
        marginBottom: 8, display: 'block',
      }}>
        Type de bien
      </label>
      <div style={{ display: 'flex', gap: 8 }}>
        {OPTIONS.map(({ type, icon: Icon, label }) => {
          const selected = value === type;
          return (
            <button
              key={type}
              type="button"
              onClick={() => onChange(type)}
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
                padding: '10px 8px',
                borderRadius: 'var(--radius-md)',
                border: selected
                  ? '0.5px solid rgba(109,40,217,0.35)'
                  : '0.5px solid var(--color-border)',
                background: selected ? '#F5F3FF' : 'white',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
              }}
            >
              <Icon
                size={20}
                strokeWidth={1.75}
                color={selected ? '#4C1D95' : '#B8B0CC'}
              />
              <span style={{
                fontSize: 11,
                fontWeight: selected ? 500 : 400,
                color: selected ? '#4C1D95' : '#7C6FA0',
                whiteSpace: 'nowrap',
              }}>
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PropertyTypeSelect;
